/* global lpia_params */

export default class DomainPriceTable {
  constructor() {
    this.init();
  }

  init() {
    const domainsTable = document.querySelector('.js-domains-table');
    const loadMoreButton = document.querySelector('.js-domains-table-load-more');
    const loadingClass = 'is-loading';

    /**
     * Call ajax for loading more domain table
     */
    function getDomains(append = true, perPage = 16) {
      if (!domainsTable) {
        return false;
      }

      let nextPage = parseInt(domainsTable.getAttribute('data-next-page')) ?? 2;

      // Reset next page, if we don't appending table
      if (!append) {
        nextPage = 1;
      }

      // Add container loading class
      loadMoreButton.classList.add(loadingClass);

      // Prepare fetch request.
      fetch(lpia_params.ajax_url, {
        method: 'POST',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        },
        body: `action=domains_table&page=${nextPage}&wp_nonce=${domainsTable.getAttribute('data-nonce')}&per_page=${perPage}&show_transfer=${domainsTable.getAttribute('data-show-transfer')}`,
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Error');
          }
        })
        .then((data) => {
          const htmlTable = 'html' in data ? data['html'] : false;
          const lastPage = 'last_page' in data ? data['last_page'] : false;

          // Check if it's the last page and we need to hide the load more button
          maybeHideLoadMoreButton(lastPage);

          // Clear container previous table, if we inserting instead of appending new table
          if (!append) {
            domainsTable.innerHTML = '';
          }

          // Update next page attr on container element
          nextPage = nextPage + 1;
          domainsTable.setAttribute('data-next-page', nextPage);

          // Append response to table container
          appendDomainsToContainer(htmlTable);
        })
        .catch((error) => {
          // Handle error.
          console.log(error);
        })
        .finally(() => {
          // Remove container loading class
          loadMoreButton.classList.remove(loadingClass);
        });
    }

    /**
     * Check if it's the last page and we need to hide the load more button
     */
    function maybeHideLoadMoreButton(isLastPage) {
      // Bail out if load more button not exists
      if (!loadMoreButton) {
        return;
      }

      if (isLastPage) {
        loadMoreButton.classList.add('hidden');
      } else {
        loadMoreButton.classList.remove('hidden');
      }
    }

    /**
     * Append table html to domains container
     */
    function appendDomainsToContainer(htmlContent) {
      // Append html string to container
      domainsTable.insertAdjacentHTML('beforeend', htmlContent);

      // Remove Loading Class
      loadMoreButton.classList.remove(loadingClass);

      // Make appended table visible with little delay effect
      let table = domainsTable.querySelectorAll('.opacity-0');
      table.forEach((card, index) => {
        setTimeout(function () {
          card.classList.remove('opacity-0');
        }, index * 25);
      });
    }

    /**
     * Call ajax on load more button click
     */
    if (loadMoreButton) {
      loadMoreButton.addEventListener(
        'click',
        (event) => {
          // Prevent default button function
          event.preventDefault();

          // Call ajax load more domain table method with append
          getDomains();
        },
        false,
      );
    }
  }
}
